import BaseInvocation from 'internal-components/src/api/invocation'

export default class Invocation extends BaseInvocation {
  constructor(endpoint, raven) {
    super(endpoint)

    if (raven) {
      this.request = raven.wrap(this.request)
    }
  }

  submitHeardAbout = (hmac, signup, heardAbout) =>
      this.signupRequest(
        hmac,
        signup,
        'POST',
        `/signup/${signup.get('id')}/heard-about`,
        {heardAbout}
      )
}



// WEBPACK FOOTER //
// ./src/api/Invocation.js